export default __webpack_public_path__ + "static/media/move_start.f5454964.mp3";